import React, { Component } from "react"
import { Link } from "gatsby"
import styled from "styled-components"

export default class Logo extends Component {
  render() {
    return (
      <LogoWrapper>
        <Link to="/">
          <p>
            <span>rum</span>
            {/* &#8286; */}
            &#8278;
            <span>exam</span>
          </p>
        </Link>
      </LogoWrapper>
    )
  }
}

const LogoWrapper = styled.div`
  display: flex;

  a {
    color: black;
    text-decoration: none;
    /* font-family: var(--poiret); */
    font-family: "Poiret One", sans-serif;
    font-size: 2rem;
    font-size: 1.6rem;
    letter-spacing: -1px;
  }

  span:first-child {
    /* font-family: var(--montserrat); */
    font-family: "Montserrat", sans-serif;
  }

  span:last-child {
    /* font-family: var(--poiret); */
    font-family: "Poiret One", sans-serif;
    font-size: 2.3rem;
    font-size: 1.9rem;
  }

  :hover span:first-child {
    /* font-family: var(--poiret); */
    font-family: "Poiret One", sans-serif;
    font-size: 2.3rem;
    font-size: 1.9rem;
  }
  :hover span:last-child {
    /* font-family: var(--montserrat); */
    font-family: "Montserrat", sans-serif;
    font-size: 2rem;
    font-size: 1.6rem;
  }
`
